export function formatToColombiaDate(date) {
    if (!date) return '-'
    return new Date(date).toLocaleString('es-CO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
    })
}